<app-modal [isActive]="isActive" (modalState)="closeModal.emit($event)" [isLarge]="true">
  <p class="modal-card-title" modal-title>
    {{ 'itinerary-info.segments-info.oag-flt-status' | translate }}
  </p>

  <div modal-content>
    <div *ngIf="(oAGFLTStatus$ | async).isError" class="card-alert-container">
      <app-alert type="error">
        <span class="weight-medium" title>{{ 'shared.operation-failed' | translate }} </span>
        <span description> {{ 'exception-mode.error-description' | translate }}</span>
      </app-alert>
    </div>

    <div *ngIf="(oAGFLTStatus$ | async).isSuccess">
      <p>{{ 'itinerary-info.flight.oag-flt-status' | translate }}*</p>

      <br />

      <div class="oagflt-table-container">
        <table>
          <tr>
            <th>{{ 'itinerary-info.flight.state' | translate }}</th>
          </tr>

          <tr>
            <div *ngFor="let status of (oAGFLTStatus$ | async).data; let i = index">
              <td>{{ status }}</td>
            </div>
          </tr>
        </table>
      </div>
    </div>
  </div>
</app-modal>
